// src/components/PyramidDisplay.js
import React from 'react';
import WordRow from './WordRow';
import { getMedal } from '../utils/medalUtils';

const PyramidDisplay = ({ wordChain, showSuccessAnimation, communityBestLength }) => {
  const isCrowded = wordChain.length >= 8;
  const isVeryCrowded = wordChain.length >= 10;

  return (
    <div className="flex flex-col items-center justify-center my-4 space-y-1">
      {wordChain.map((word, index) => {
        const isLastWord = index === wordChain.length - 1;
        const rowAnimationClass = isLastWord && showSuccessAnimation ? 'animate-pop-in' : '';
        
        let tileAnimationClass = isLastWord && showSuccessAnimation ? 'animate-pop-in-color' : '';

        // Determine medal color for this word
        const medal = getMedal(word.length, communityBestLength);
        let medalClass = '';
        if (medal === 'bronze') medalClass = 'bg-bronze text-white border-bronze';
        else if (medal === 'silver') medalClass = 'bg-silver text-gray-800 border-silver';
        else if (medal === 'gold') medalClass = 'bg-gold text-gray-900 border-gold';
        else if (medal === 'platinum') medalClass = 'bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white border-transparent';

        return (
          <WordRow 
            key={index} 
            word={word} 
            isCrowded={isCrowded} 
            isVeryCrowded={isVeryCrowded} 
            extraClass={rowAnimationClass}
            tileExtraClass={`${tileAnimationClass} ${medalClass}`}
            medal={medal}
          />
        );
      })}
    </div>
  );
};

export default PyramidDisplay;
